/**
 * Projects opened lately in this browser, newest first: "Starred and recent" lists them next to
 * the boards (boards have their own history on the server).
 */
const KEY = 'vatman.recent.projects';
const MAX = 12;

export function recentProjects(): { id: string; at: number }[] {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) ?? '[]');
    return Array.isArray(v) ? v.filter((x) => typeof x?.id === 'string' && typeof x?.at === 'number').slice(0, MAX) : [];
  } catch {
    return [];
  }
}

export function rememberProject(id: string) {
  try {
    const rest = recentProjects().filter((x) => x.id !== id);
    localStorage.setItem(KEY, JSON.stringify([{ id, at: Date.now() }, ...rest].slice(0, MAX)));
  } catch {
    // Not critical: the list just misses this visit.
  }
}

/*
 * The view last opened in each project (board, list, backlog…): the menu's one row per project
 * goes back there (docs/navigation-v2-plan.md).
 */
const VIEWS = 'vatman.project.views';

function views(): Record<string, string> {
  try {
    const v = JSON.parse(localStorage.getItem(VIEWS) ?? '{}');
    return v && typeof v === 'object' ? v : {};
  } catch {
    return {};
  }
}

export function rememberProjectView(id: string, view: string) {
  try {
    const all = views();
    if (all[id] === view) return;
    localStorage.setItem(VIEWS, JSON.stringify({ ...all, [id]: view }));
  } catch {
    // Not critical: the project just opens on its board.
  }
}

/** The address of a project at its last view. */
export function projectLink(id: string): string {
  const v = views()[id];
  return v && v !== 'board' && v !== 'settings' ? `/t/${id}?view=${v}` : `/t/${id}`;
}
